function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ClickContainer from 'shared/components/ClickContainer';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
var SubNavigationItem = function SubNavigationItem(_ref) {
  var ChildComponent = _ref.childComponent,
    item = _ref.item,
    listItemClassName = _ref.listItemClassName,
    linkClassName = _ref.linkClassName,
    _ref$onLinkClick = _ref.onLinkClick,
    onLinkClick = _ref$onLinkClick === void 0 ? function () {} : _ref$onLinkClick;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownVisible = _useState2[0],
    setDropdownVisible = _useState2[1];
  var dismissDropdown = function dismissDropdown() {
    return setDropdownVisible(false);
  };
  var subNavigationItemClassName = [item.active ? 'active' : null, listItemClassName, item.children ? 'dropdown' : null, dropdownVisible ? 'show' : null].filter(function (className) {
    return className;
  }).join(' ');
  return /*#__PURE__*/React.createElement(ClickContainer, {
    component: "li",
    className: subNavigationItemClassName,
    key: item.name,
    onClickOutside: dismissDropdown
  }, !item.children ? /*#__PURE__*/React.createElement(Link, {
    to: item.url,
    className: linkClassName,
    onClick: onLinkClick
  }, /*#__PURE__*/React.createElement(T, {
    source: item.name,
    params: item.params
  })) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setDropdownVisible(!dropdownVisible);
    },
    className: linkClassName
  }, /*#__PURE__*/React.createElement(T, {
    source: item.name,
    params: item.params
  }), dropdownVisible ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-chevron-up"
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-chevron-down"
  })), dropdownVisible && item.children ? /*#__PURE__*/React.createElement(ChildComponent, {
    childItems: item.children,
    onLinkClick: dismissDropdown
  }) : null);
};
export default SubNavigationItem;